<div
  class="shared-participant-stack"
  role="group"
  aria-label="Thread participants"
>
  @for (slot of visibleSlots(); track slot.key) {
    <span
      class="shared-participant-stack__avatar"
      [ngClass]="slot.colorClass"
      [class.shared-participant-stack__avatar--bounced]="slot.isBounced"
      [matTooltip]="slot.tooltip"
      [attr.aria-label]="slot.tooltip"
      [attr.data-bounced]="slot.isBounced ? 'true' : null"
      [attr.data-testid]="'participant-avatar-' + slot.key"
    >
      {{ slot.initials }}
      @if (slot.isBounced) {
        <span
          class="shared-participant-stack__bounce-badge"
          [matTooltip]="slot.bounceTooltip"
          [attr.aria-label]="slot.bounceTooltip"
          [attr.data-testid]="'participant-bounce-badge-' + slot.key"
        ></span>
      }
    </span>
  }
  @if (overflowCount() > 0) {
    <span
      class="shared-participant-stack__overflow"
      [matTooltip]="overflowTooltip()"
      [attr.aria-label]="
        'Plus ' + overflowCount() + ' more: ' + overflowTooltip()
      "
      tabindex="0"
    >
      +{{ overflowCount() }}
    </span>
  }
</div>
